export default "__VITE_ASSET__4061c22e__"